import type { people as pt } from '../pt/people';
// English mirror of ../pt/people.ts (shape checked against its pt twin).
export const people: typeof pt = {
  list: {
    title: 'Collaborators',
    countOne: '{n} collaborator',
    countMany: '{n} collaborators',
    syncTitle: 'Pull collaborators from SISTRADE',
    sync: 'Sync Data',
    syncing: 'Syncing…',
    deleted: 'Deleted',
    new: 'New collaborator',
    syncDone: 'Sync complete: {total} collaborators ({created} created, {updated} updated).',
    syncFailed: 'Sync failed: {error}.',
    unknownError: 'unknown error',
    newNamePlaceholder: 'Collaborator full name',
    create: 'Create',
    filterByStatus: 'Filter by status',
    statusActive: 'Active',
    statusAll: 'All',
    statusInactive: 'Inactive',
    missingTitle: 'Show only collaborators with required fields to fill',
    missing: 'Missing data',
    hideExternalTitle: 'Hide external collaborators (shown by default)',
    hideExternal: 'No externals',
    clearFilters: 'Clear filters',
    searchPlaceholder: 'Search by name, code, department…',
    empty: 'No results for your search.',
    col: {
      code: 'Code',
      name: 'Name',
      department: 'Department',
      situation: 'Situation',
      contractStart: 'Contract start',
      contractEnd: 'Contract end',
      dedication: '% Ded.',
      state: 'Status',
    },
    missDotTitle: 'Has required fields to fill',
    missDotAria: 'Required data missing',
    external: 'External',
    showing: 'Showing {visible} of {total}…',
    flag: {
      expired: 'Expired',
      lt1: '< 1 month',
      lt3: '< 3 months',
      lt6: '< 6 months',
    },
    dept: {
      label: 'Department',
      filterPlaceholder: 'Filter departments…',
      clear: 'Clear selection ({n})',
      empty: 'No departments',
    },
  },
  record: {
    notFound: 'Collaborator not found.',
    back: '← Collaborators',
    history: 'History',
    deleteTitle: 'Delete the collaborator (only within the first 72h)',
    saving: 'Saving…',
    saved: 'Saved.',
    missingRequired: 'Missing {n} required field(s):',
    emptySection: 'No fields in this section.',
    empty: '(empty)',
    reserved: 'reserved',
    statusAria: 'Status',
    deleteConfirm:
      'Delete the collaborator "{name}"?\n\nOnly possible within the first 72 hours after creation. The record goes to a bin accessible only to administrators, who can restore it.',
    field: {
      code: 'Code',
      fullName: 'Name',
      shortName: 'Short name',
      personalEmail: 'Personal Email',
      professionalEmail: 'Professional Email',
      orcid: 'ORCID',
      cienciaId: 'CIÊNCIA ID',
      scopusAuthorId: 'SCOPUS AUTHOR ID',
      situacao: 'Collaborator Status',
    },
    hist: {
      title: 'Change history',
      noHistory: 'No changes recorded.',
      date: 'Date',
      field: 'Field',
      from: 'From',
      to: 'To',
      source: 'Source',
      manual: 'Manual',
    },
    confirmLeave: {
      title: 'Unsaved changes',
      body: 'You have unsaved changes on this record:',
      discard: 'Discard',
      save: 'Save changes',
    },
  },
  deleted: {
    title: 'Deleted collaborators',
    subtitle: 'Bin — deleted records that can be restored',
    back: '← Collaborators',
    adminOnly: 'This area is reserved for portal administrators.',
    empty: 'No deleted records.',
    restore: 'Restore',
    col: {
      code: 'Code',
      name: 'Name',
      state: 'Status',
      created: 'Created',
      deleted: 'Deleted',
      by: 'By',
    },
  },
  profile: {
    title: 'My Profile',
    noFicha: {
      before:
        'Your account is not yet linked to a collaborator record. The link is made through the ',
      after:
        ' field of the record (or the professional email). Ask Onboarding or HR to fill that field with your username.',
    },
  },
  similar: {
    one: '1 similar name',
    many: '{n} similar names',
    heading: 'Collaborators with an identical or similar name',
  },
};
